import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API_ROUTES from "../../../api-routes";
import apiService from "../../../services/service";

const initialState = {
  loadingmilestones: false,
};

export const fetchMilestones = createAsyncThunk(
  "milestoneSlice/fetchMilestones",
  async (arg) => {
    // Support both old signature (id string) and new signature ({ id, skipCache })
    const id = typeof arg === "string" ? arg : arg.id;
    const skipCache = typeof arg === "object" ? arg.skipCache : false;
    const data = await apiService(API_ROUTES.FETCH_MILESTONES, "GET", {
      replace: { id },
      skipCache,
    });
    return data;
  },
);

const milestoneSlice = createSlice({
  name: "milestoneSlice",
  initialState,
  reducers: {
    updateTaskFlag: (state, { payload }) => {
      // Update a task's flag status locally without re-fetching all milestones
      // This prevents the milestone order from changing when a flag is added/removed
      const { taskId, flagStatus, latestFlaggedAt } = payload;
      if (state.processmilestones) {
        // Create a new array to ensure React detects the change
        state.processmilestones = state.processmilestones.map((milestone) => {
          const task = milestone.taskData?.find((t) => t.id === taskId);
          if (task) {
            // Calculate the new flagged tasks count
            const updatedTaskData = milestone.taskData.map((t) =>
              t.id === taskId
                ? {
                    ...t,
                    flag: flagStatus,
                    ...(latestFlaggedAt && {
                      latest_flagged_at: latestFlaggedAt,
                    }),
                  }
                : t,
            );
            const numberof_flagged_tasks = updatedTaskData.filter(
              (t) => t.flag,
            ).length;

            return {
              ...milestone,
              taskData: updatedTaskData,
              numberof_flagged_tasks,
            };
          }
          return milestone;
        });
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMilestones.pending, () => {})
      .addCase(fetchMilestones.fulfilled, (state, { payload }) => {
        state.processmilestones = payload?.data;
      })
      .addCase(fetchMilestones.rejected, () => {});
  },
});

export const { updateTaskFlag } = milestoneSlice.actions;
export default milestoneSlice.reducer;
